/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CrefoMonitoringStatusDto } from '../../models/crefo-monitoring-status-dto';

export interface GetMonitoringStatus$Params {
  customerGUID: string;
  pageSize: number;
  pageReference?: number;
}

export function getMonitoringStatus(http: HttpClient, rootUrl: string, params: GetMonitoringStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CrefoMonitoringStatusDto>> {
  const rb = new RequestBuilder(rootUrl, getMonitoringStatus.PATH, 'get');
  if (params) {
    rb.query('customerGUID', params.customerGUID, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('pageReference', params.pageReference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CrefoMonitoringStatusDto>;
    })
  );
}

getMonitoringStatus.PATH = '/crefo/monitoring/status';
